import { useEffect } from 'react';

import { displaySequencedFlow } from '../../../actions/contentItemActions';
import { isSequencedFlowStep, SequencedFlowChildrenTypes } from '@ael/core-api';
import { FriendlyNameService, IPanorama, PanoramaArrowIdentifier } from '@ael/core-api';
import { useDispatch } from 'react-redux';

/**
 * Binds given panorama to linear flow step content item.
 * Panorama is updated accordingly to the content item.
 * When component is un-mounted then panorama is cleared.
 *
 * @param panorama Panorama to set its camera position.
 * @param item Item with position/arrow and camera.
 */
export const useBindPanoramaWithStudentLinearFlowStep = (
  panorama: IPanorama,
  item: SequencedFlowChildrenTypes | null
): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (item && isSequencedFlowStep(item)) {
      if (item.position) {
        const arrowId: PanoramaArrowIdentifier = FriendlyNameService.getFriendlyName(item.id);
        panorama.renderArrowToPano(item.position, arrowId, { onClick: () => dispatch(displaySequencedFlow()) });
      }

      if (item.cameraPosition) {
        panorama.lookToCameraPosition(item.cameraPosition);
      } else if (item.position) {
        panorama.lookToArrow(item.position);
      }
    }
    return () => {
      if (item && isSequencedFlowStep(item)) {
        const arrowId: PanoramaArrowIdentifier = FriendlyNameService.getFriendlyName(item.id);
        panorama.removeArrow(arrowId);
      }
    };
  }, [dispatch, item, panorama]);
};
